import React from 'react';
import './styles/Experience.css'; // Importing styles
import 'bootstrap/dist/css/bootstrap.min.css'; // Importing bootstrap styles

// Reusable component for experience items
const ExperienceItem = ({
	role,
	company,
	location,
	date,
	description,
	keyProjects,
}) => (
	<div className="experience-item mb-4">
		<h3>{role}</h3>
		<p>
			<strong>
				{company} / {location} / {date}
			</strong>
		</p>
		<p>{description}</p>
		{keyProjects && (
			<>
				<h4>Key Projects:</h4>
				<ul>
					{keyProjects.map((project, index) => (
						<li key={index}>
							<a href={project.url} target="_blank" rel="noopener noreferrer">
								{project.name}
							</a>{' '}
							- {project.description}
						</li>
					))}
				</ul>
			</>
		)}
	</div>
);

const Experience = () => {
	return (
		<div className="container mb-5 experience-container">
			{/* Front-End Freelancer */}
			<ExperienceItem
				role="Front-End Freelancer"
				company="Toprak Web Development"
				location="Utrecht (Remote)"
				date="06.2024 – Present"
				description="As a freelance Front-End Developer, I am working with various clients to create responsive, high-performance web applications. My focus is on delivering user-centric solutions using modern web technologies like React, Next.js, and Tailwind. Also, since Sep 2021, I have been working for Thuisbezorgd.nl as City Captain in my free time to embrace Dutch culture while staying active and connecting with others."
				keyProjects={[
					{
						name: 'Dark Office',
						url: 'https://dark-office.vercel.app',
						description:
							'A website for a Manufacturing Execution System and Manufacturing Operations Management. (Tech: Typescript, Next.js, Tailwind)',
					},
					{
						name: 'Ertuna Metal',
						url: 'https://ertunametal.com',
						description:
							'A website for a metal company from Turkey. (Tech: Typescript, Next.js, Tailwind)',
					},
					{
						name: 'Ece & Mert Wedding Page',
						url: 'https://ecemertwedding.netlify.app',
						description:
							'A website for our wedding with a backend for RSVP system. (Tech: JS, Express.js, Bootstrap, MongoDB)',
					},
				]}
			/>

			{/* Full-Stack Developer */}
			<ExperienceItem
				role="Full-Stack Developer"
				company="Antler"
				location="Berlin (Remote)"
				date="03.2024 – 05.2024"
				description="Completed an internship by developing a Dynamic UI Builder & Tracker app from scratch. Worked closely with a peer developer, UI designer, and head of application, contributing to both frontend and backend development in an agile environment."
				keyProjects={[
					{
						name: 'Dynamic UI Builder & Tracker',
						description:
							'Developed and deployed a dynamic user interface builder application, contributing to frontend (React, Tailwind) and backend (Node.js) development.',
					},
				]}
			/>

			{/* Front-End Developer */}
			<ExperienceItem
				role="Front-End Developer"
				company="Rollic"
				location="Istanbul (Remote)"
				date="12.2023 – 03.2024"
				description="Rollic is a leading mobile gaming company, creating globally popular hyper-casual games. During my internship, I collaborated with experienced developers, gaining hands-on experience in front-end development and the gaming industry."
				keyProjects={[
					{
						name: 'Company Website Revamp',
						description:
							'Developed responsive web pages improving the company website’s user experience using HTML, CSS, and JavaScript.',
					},
				]}
			/>

			{/* Product Manager */}
			<ExperienceItem
				role="Product Manager"
				company="4PLAY"
				location="Istanbul"
				date="09.2019 – 09.2022"
				description="My team and I developed chatbot applications where users played text-based games to earn mobile data. We collaborated closely with Turkcell, Turkey’s largest mobile and internet operator."
				keyProjects={[
					{
						name: 'Mobile Data Chatbot',
						description:
							'Launched a product across multiple platforms, successfully reaching over 10 million active users and 1.5 million paid users.',
					},
				]}
			/>
		</div>
	);
};

export default Experience;
